import React, { useState } from "react";

// APP COMPONENTS
import { fiscalTicketTypeFrame } from "../../common/frames";

// MATERIAL UI COMPONENTS
import {
  AutocompleteStyledPaper,
  AutocompleteStyledPopper,
  StyledAutocomplete,
} from "../styled/inputs/autocomplete";
import { StyledTextField } from "../styled/inputs/textInput";

const FiscalTicketTypeFilter = ({ selectedValue, onFilterChange }) => {
  const [status, setStatus] = useState(fiscalTicketTypeFrame);

  return (
    <StyledAutocomplete
      disablePortal={false}
      id="fiscal-ticket-types"
      options={status}
      defaultValue={status[0]}
      getOptionLabel={(option) => option.label}
      groupBy={(option) => option.firstLetter}
      renderInput={(params) => (
        <StyledTextField
          {...params}
          label="Tipo"
          variant="outlined"
          InputProps={{
            ...params.InputProps,
          }}
        />
      )}
      PopperComponent={(props) => <AutocompleteStyledPopper {...props} />}
      PaperComponent={(props) => <AutocompleteStyledPaper {...props} />}
      onChange={(event, values) => {
        onFilterChange(values);
      }}
      sx={{ mb: 1 }}
    />
  );
};

FiscalTicketTypeFilter.displayName = "Tipo";

export default FiscalTicketTypeFilter;
